

export class CardInfo{
    cardType!: CardType;
    count!: number;
    description!: string;
    isActive!: boolean;
}

export enum CardNews {
    GIFT_3_ELEPHANT = "GIFT_3_ELEPHANT",
}
export enum CardType {
    ELEPHANT = "ELEPHANT",
    SNAKE = "SNAKE",
    EAGLE = "EAGLE"
}

export class CardState {
    activeCard: CardType | null = null;
}